<div id="graph">
  <canvas style="width: 100%" id="canvas" #canvas></canvas>
</div>